import React, { useState } from 'react';
import './App.css';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activePage, setActivePage] = useState('home');

  const navigate = (page) => {
    setActivePage(page);
    setMenuOpen(false);
    window.scrollTo(0, 0);
  };

  return (
    <div className="app">
      {/* NAVBAR */}
      <nav className="navbar">
        <div className="nav-brand" onClick={() => navigate('home')}>
          <div className="nav-logo">🦅</div>
          <div>
            <div className="nav-title">TAXIFY</div>
            <div className="nav-sub">Advisor</div>
          </div>
        </div>
        <div className="nav-links desktop-only">
          <button onClick={() => navigate('home')} className={activePage === 'home' ? 'nav-btn active' : 'nav-btn'}>Home</button>
          <button onClick={() => navigate('services')} className={activePage === 'services' ? 'nav-btn active' : 'nav-btn'}>Services</button>
          <button onClick={() => navigate('checklist')} className={activePage === 'checklist' ? 'nav-btn active' : 'nav-btn'}>Checklist</button>
          <button onClick={() => navigate('contact')} className={activePage === 'contact' ? 'nav-btn active' : 'nav-btn'}>Contact</button>
          <a href="https://wa.me/923002241149" className="nav-wa-btn" target="_blank" rel="noreferrer">WhatsApp Us</a>
        </div>
        <button className="hamburger mobile-only" onClick={() => setMenuOpen(!menuOpen)}>☰</button>
      </nav>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div className="mobile-menu">
          <button onClick={() => navigate('home')} className="mob-link">🏠 Home</button>
          <button onClick={() => navigate('services')} className="mob-link">📋 Services</button>
          <button onClick={() => navigate('checklist')} className="mob-link">📁 Document Checklist</button>
          <button onClick={() => navigate('contact')} className="mob-link">📞 Contact</button>
          <a href="https://wa.me/923002241149" className="mob-wa" target="_blank" rel="noreferrer">💬 WhatsApp Us Now</a>
        </div>
      )}

      {/* PAGES */}
      {activePage === 'home' && <HomePage navigate={navigate} />}
      {activePage === 'services' && <ServicesPage />}
      {activePage === 'checklist' && <ChecklistPage />}
      {activePage === 'contact' && <ContactPage />}

      {/* FOOTER */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">🦅 TAXIFY Advisor</div>
            <div className="footer-tag">Your Trusted Tax & Business Partner</div>
          </div>
          <div className="footer-links">
            <button onClick={() => navigate('home')} className="f-link">Home</button>
            <button onClick={() => navigate('services')} className="f-link">Services</button>
            <button onClick={() => navigate('checklist')} className="f-link">Checklist</button>
            <button onClick={() => navigate('contact')} className="f-link">Contact</button>
          </div>
          <div className="footer-contact">
            <div>📞 +92 300 2241149</div>
            <div>📧 taxifyadvisor@gmail.com</div>
            <div>📍 PECHS Block 6, Karachi</div>
          </div>
        </div>
        <div className="footer-bottom">
          © 2025 TAXIFY Advisor. All rights reserved. | FBR Registered Tax Consultant
        </div>
      </footer>
    </div>
  );
}

/* ── HOME PAGE ─────────────────────────────────────────── */
function HomePage({ navigate }) {
  return (
    <div>
      {/* HERO */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-tag">FBR Registered · Tax Consultant · Karachi</div>
          <h1 className="hero-title">Pakistan's Tax.<br /><span className="gold">Simplified.</span></h1>
          <p className="hero-sub">Professional tax consultancy for individuals, businesses and freelancers across Pakistan. Fast, affordable and 100% FBR compliant.</p>
          <div className="hero-btns">
            <a href="https://wa.me/923002241149" className="btn-gold" target="_blank" rel="noreferrer">💬 WhatsApp Us Now</a>
            <button className="btn-outline" onClick={() => navigate('services')}>Our Services →</button>
          </div>
          <div className="hero-stats">
            <div className="stat"><div className="stat-num">767+</div><div className="stat-label">Facebook Followers</div></div>
            <div className="stat-divider"></div>
            <div className="stat"><div className="stat-num">4.7★</div><div className="stat-label">Google Rating</div></div>
            <div className="stat-divider"></div>
            <div className="stat"><div className="stat-num">FBR</div><div className="stat-label">Registered</div></div>
          </div>
        </div>
      </section>

      {/* FILER VS NON-FILER */}
      <section className="section">
        <div className="container">
          <div className="section-tag">Did You Know?</div>
          <h2 className="section-title">Filer vs <span className="gold">Non-Filer</span></h2>
          <p className="section-sub">Filing your tax return saves you lakhs on every major transaction</p>
          <div className="compare-grid">
            {[
              ['Bank Withdrawal', '0.15%', '0.60%'],
              ['Property Purchase', '3%', '7%'],
              ['Property Sale', '3%', '10%'],
              ['Dividends', '15%', '30%'],
              ['Contracts', '7%', '14%'],
            ].map(([cat, filer, nonfiler]) => (
              <div key={cat} className="compare-row">
                <div className="compare-cat">{cat}</div>
                <div className="compare-filer">✅ Filer: <strong>{filer}</strong></div>
                <div className="compare-nonfiler">❌ Non-Filer: <strong>{nonfiler}</strong></div>
              </div>
            ))}
          </div>
          <div className="saving-banner">
            💡 Buying property worth PKR 50 lakh? Filer pays PKR 1.5L — Non-Filer pays PKR 3.5L
            <strong> = PKR 2 LAKH saved by filing!</strong>
          </div>
          <div className="deadline-pill">⏳ Filing Deadline: 30 September 2025 — Don't wait!</div>
        </div>
      </section>

      {/* QUICK SERVICES */}
      <section className="section dark-section">
        <div className="container">
          <div className="section-tag">What We Do</div>
          <h2 className="section-title" style={{color:'#E8C96A'}}>Our <span style={{color:'#C9A84C'}}>Services</span></h2>
          <div className="services-grid">
            {[
              ['📄', 'Income Tax Returns', 'Salaried, business & freelancers'],
              ['🔑', 'NTN Registration', 'New registration & ATL enrollment'],
              ['📊', 'Sales Tax Returns', 'FBR, SRB, PRA & KPRA filing'],
              ['⚖️', 'Tax Disputes', 'FBR notices & audit handling'],
              ['🏢', 'Business Tax Advisory', 'Corporate planning & e-Invoicing'],
              ['📚', 'Bookkeeping', 'Financial statements & payroll'],
            ].map(([icon, title, desc]) => (
              <div key={title} className="service-card">
                <div className="service-icon">{icon}</div>
                <div className="service-title">{title}</div>
                <div className="service-desc">{desc}</div>
              </div>
            ))}
          </div>
          <div className="center-btn">
            <button className="btn-gold" onClick={() => navigate('services')}>View All Services →</button>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <h2 className="cta-title">Ready to become a <span className="gold">Filer?</span></h2>
          <p className="cta-sub">Contact us today — it's fast, affordable and hassle-free</p>
          <div className="hero-btns">
            <a href="https://wa.me/923002241149" className="btn-gold" target="_blank" rel="noreferrer">💬 WhatsApp Now</a>
            <a href="tel:+923002241149" className="btn-outline">📞 Call Now</a>
          </div>
        </div>
      </section>
    </div>
  );
}

/* ── SERVICES PAGE ─────────────────────────────────────── */
function ServicesPage() {
  const services = [
    {
      icon: '📄',
      title: 'Income Tax Returns',
      desc: 'Filing of annual income tax returns for salaried individuals, business owners, and freelancers on FBR IRIS portal. Fast, accurate and deadline-compliant.',
      items: ['Salaried individuals', 'Business owners', 'Freelancers & consultants', 'NTN holders'],
    },
    {
      icon: '🔑',
      title: 'NTN Registration & ATL',
      desc: 'New NTN registration and Active Taxpayer List enrollment. Become a filer and save on every bank transaction, property deal and contract.',
      items: ['New NTN registration', 'ATL enrollment', 'CNIC-NTN linkage', 'Password recovery'],
    },
    {
      icon: '📊',
      title: 'Sales Tax Returns',
      desc: 'Monthly sales tax return filing for FBR, SRB, PRA and KPRA registered businesses. Never miss a deadline again.',
      items: ['FBR sales tax', 'SRB (Sindh)', 'PRA (Punjab)', 'e-Invoicing SRO 709'],
    },
    {
      icon: '⚖️',
      title: 'Tax Dispute Resolution',
      desc: 'Handling FBR audit notices, show-cause replies, penalty waivers and representation before Commissioner Inland Revenue.',
      items: ['Audit notices', 'Show-cause replies', 'Penalty waivers', 'CIR representation'],
    },
    {
      icon: '🏢',
      title: 'Business Tax Advisory',
      desc: 'Corporate tax planning, super tax compliance, e-Invoicing setup and SECP annual return filing for businesses.',
      items: ['Corporate tax planning', 'Super tax compliance', 'SECP filings', 'WHT statements'],
    },
    {
      icon: '📚',
      title: 'Bookkeeping & Accounting',
      desc: 'Financial statement preparation, payroll tax calculations, withholding tax records and FBR-ready accounts.',
      items: ['Financial statements', 'Payroll management', 'WHT records', 'Accounts reconciliation'],
    },
  ];

  return (
    <div>
      <section className="page-hero">
        <div className="section-tag">What We Offer</div>
        <h1 className="page-title">Our <span className="gold">Services</span></h1>
        <p className="page-sub">Complete FBR tax solutions for individuals and businesses across Pakistan</p>
      </section>
      <section className="section">
        <div className="container">
          <div className="services-detail-grid">
            {services.map((s) => (
              <div key={s.title} className="service-detail-card">
                <div className="sd-icon">{s.icon}</div>
                <div className="sd-title">{s.title}</div>
                <div className="sd-desc">{s.desc}</div>
                <ul className="sd-list">
                  {s.items.map((item) => (
                    <li key={item} className="sd-item">✅ {item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <div className="not-sure-box">
            <div className="ns-title">Not sure which service you need?</div>
            <div className="ns-sub">WhatsApp us and we will guide you for free</div>
            <a href="https://wa.me/923002241149" className="btn-gold" target="_blank" rel="noreferrer">💬 WhatsApp: +92 300 2241149</a>
          </div>
        </div>
      </section>
    </div>
  );
}

/* ── CHECKLIST PAGE ────────────────────────────────────── */
function ChecklistPage() {
  const [type, setType] = useState('salaried');

  const common = [
    'CNIC front & back (clear photo)',
    'NTN number',
    'FBR IRIS mobile number & password',
    'Bank account number + IBAN',
    'Assets on 30 June 2025 (property, vehicle, gold, cash, savings)',
    'Any loans or liabilities',
  ];

  const salaried = [
    'Salary certificate / slip (Jul 2024 – Jun 2025)',
    'Total annual salary income',
    'Tax deducted by employer (WHT amount)',
    'Rent income (if any)',
    'Profit on savings / bank certificate (if any)',
    'Dividend income (if any)',
    'Foreign remittances (if any)',
    'Provident fund / gratuity (if any)',
  ];

  const business = [
    'Business name and nature',
    'Total sales / turnover (Jul 2024 – Jun 2025)',
    'Business expenses (rent, salaries, purchases, utilities)',
    'Net profit for the year',
    'Sales Tax Registration STRN (if any)',
    'Withholding tax paid / challan copies (if any)',
    'Advance tax paid Challan 9 (if any)',
    'Import / export documents (if any)',
  ];

  return (
    <div>
      <section className="page-hero">
        <div className="section-tag">Tax Return 2025</div>
        <h1 className="page-title">Document <span className="gold">Checklist</span></h1>
        <p className="page-sub">FY 2024–25 (Jul 2024 – Jun 2025) · Deadline: 30 September 2025</p>
      </section>
      <section className="section">
        <div className="container">
          <div className="type-toggle">
            <button className={type === 'salaried' ? 'toggle-btn active' : 'toggle-btn'} onClick={() => setType('salaried')}>👤 Salaried Individual</button>
            <button className={type === 'business' ? 'toggle-btn active' : 'toggle-btn'} onClick={() => setType('business')}>🏢 Business Individual</button>
          </div>

          <div className="checklist-section">
            <div className="cl-head gold-head">📋 Common Documents — Everyone needs these</div>
            {common.map((item) => (
              <div key={item} className="cl-item">
                <span className="cl-dot gold-dot"></span>
                <span>{item}</span>
                <span className="cl-must">Must</span>
              </div>
            ))}
          </div>

          <div className="checklist-section">
            <div className={`cl-head ${type === 'salaried' ? 'blue-head' : 'green-head'}`}>
              {type === 'salaried' ? '👔 Salaried Individual — Additional Documents' : '🏢 Business Individual — Additional Documents'}
            </div>
            {(type === 'salaried' ? salaried : business).map((item, i) => (
              <div key={item} className="cl-item">
                <span className={`cl-dot ${type === 'salaried' ? 'blue-dot' : 'green-dot'}`}></span>
                <span>{item}</span>
                <span className={i < 4 ? 'cl-must' : 'cl-if'} >{i < 4 ? 'Must' : 'If any'}</span>
              </div>
            ))}
          </div>

          <div className="deadline-box">
            <div className="db-title">⏳ Filing Deadline: 30 September 2025</div>
            <div className="db-sub">Late filing attracts minimum PKR 40,000 fine under Section 182</div>
          </div>

          <div className="not-sure-box">
            <div className="ns-title">Ready to file? Send us your documents on WhatsApp</div>
            <a href="https://wa.me/923002241149?text=Assalam+o+Alaikum!+I+want+to+file+my+tax+return+2025" className="btn-gold" target="_blank" rel="noreferrer">💬 Send Documents on WhatsApp</a>
          </div>
        </div>
      </section>
    </div>
  );
}

/* ── CONTACT PAGE ──────────────────────────────────────── */
function ContactPage() {
  return (
    <div>
      <section className="page-hero">
        <div className="section-tag">Get In Touch</div>
        <h1 className="page-title">Contact <span className="gold">Us</span></h1>
        <p className="page-sub">We are just one message away — reach us on any platform</p>
      </section>
      <section className="section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-card">
              <div className="cc-icon">📞</div>
              <div className="cc-title">Call / WhatsApp</div>
              <div className="cc-val">+92 300 2241149</div>
              <div className="cc-val">+92 346 3295786</div>
              <a href="https://wa.me/923002241149" className="cc-btn" target="_blank" rel="noreferrer">WhatsApp Now</a>
            </div>
            <div className="contact-card">
              <div className="cc-icon">📧</div>
              <div className="cc-title">Email</div>
              <div className="cc-val">taxifyadvisor@gmail.com</div>
              <a href="mailto:taxifyadvisor@gmail.com" className="cc-btn">Send Email</a>
            </div>
            <div className="contact-card">
              <div className="cc-icon">🔵</div>
              <div className="cc-title">Facebook</div>
              <div className="cc-val">facebook.com/TaxifyAdvisor</div>
              <a href="https://web.facebook.com/TaxifyAdvisor" className="cc-btn" target="_blank" rel="noreferrer">Follow Us</a>
            </div>
            <div className="contact-card">
              <div className="cc-icon">📍</div>
              <div className="cc-title">Office Address</div>
              <div className="cc-val">Business Center, PECHS Block 6</div>
              <div className="cc-val">Main Shahrah-e-Faisal, Karachi</div>
              <a href="https://tinyurl.com/272dyrpr" className="cc-btn" target="_blank" rel="noreferrer">Get Directions</a>
            </div>
            <div className="contact-card">
              <div className="cc-icon">🗺</div>
              <div className="cc-title">Google Maps</div>
              <div className="cc-val">Find us on Google Maps</div>
              <a href="https://tinyurl.com/272dyrpr" className="cc-btn" target="_blank" rel="noreferrer">Open Maps</a>
            </div>
            <div className="contact-card">
              <div className="cc-icon">🕐</div>
              <div className="cc-title">Office Hours</div>
              <div className="cc-val">Monday – Saturday</div>
              <div className="cc-val">10:00 AM – 7:00 PM</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default App;